<nav class="ui-breadcrumbs" [attr.aria-label]="ariaLabel()">
  <ol class="ui-breadcrumbs__list">
    @for (item of ancestors(); track $index) {
      <li class="ui-breadcrumbs__item">
        @if (item.link) {
          <a class="ui-breadcrumbs__link" [routerLink]="item.link">
            @if (item.icon) {
              <ui-icon [name]="item.icon" size="sm" />
            }
            {{ item.label }}
          </a>
        } @else {
          <span class="ui-breadcrumbs__text">
            @if (item.icon) {
              <ui-icon [name]="item.icon" size="sm" />
            }
            {{ item.label }}
          </span>
        }
      </li>
    }
    @if (current(); as item) {
      <li class="ui-breadcrumbs__item ui-breadcrumbs__item--current" aria-current="page">
        <span class="ui-breadcrumbs__text">
          @if (item.icon) {
            <ui-icon [name]="item.icon" size="sm" />
          }
          {{ item.label }}
        </span>
      </li>
    }
  </ol>
</nav>
